// 별 아이템 클래스 - 디버그 로그 출력
class Star extends Item {
  constructor(scene, x = 0, z = 0) {
    super(scene, x, z);

    this.modelPath = ItemConfig.STAR.MODEL_PATH;
  }

  // 별 아이템 효과 적용 - 경험치/레벨 건드리지 않고 업그레이드 창만 열기
  applyEffect(player) {
    if (!player) return;

    // 한국어 주석: 레벨업 없이 업그레이드 창만 표시 (경험치 차감 X, 레벨업 X)
    if (window.game && window.game.upgradeManager) {
      window.game.upgradeManager.showUpgradeOptions();
    }
  }

  // 별만의 발광 효과 (황금빛)
  applyCollectionGlow(child, progress) {
    // 황금색으로 반짝이는 발광 효과
    const redIntensity = Math.floor(0x666600 + 0x999900 * progress);
    const greenIntensity = Math.floor(0x666600 + 0x999900 * progress);
    const blueIntensity = Math.floor(0x111100 + 0x444400 * progress);
    const glowColor =
      (redIntensity << 16) | (greenIntensity << 8) | blueIntensity;
    child.material.emissive.setHex(glowColor);
  }

  // 수집 효과 연출 (별 효과로 이름 변경)
  playCollectionEffect() {
    this.playStarEffect();

    if (this.collectedPlayer) {
      this.applyEffect(this.collectedPlayer);
    }
  }

  // 별 수집 효과 연출
  playStarEffect() {
    // 반짝임 효과나 사운드 효과를 여기에 구현
    // Utils.log("✨ 별 반짝임 효과!");
  }

  // 별은 반짝이는 효과 추가
  update(deltaTime) {
    super.update(deltaTime);

    if (!this.isLoaded || this.isCollected || !this.model) return;

    // 반짝임 효과
    const elapsedTime = (performance.now() - this.startTime) / 1000;
    const twinkleSpeed = 5.0; // 반짝임 속도
    const intensity = (Math.sin(elapsedTime * twinkleSpeed) + 1) * 0.5; // 0~1 사이값

    // 모델의 재질에 황금빛 효과 추가
    this.model.traverse((child) => {
      if (child.isMesh && child.material) {
        // 원본 색상과 황금색을 섞어서 반짝임 효과
        if (!child.material.originalEmissive) {
          child.material.originalEmissive = child.material.emissive.clone();
        }
        child.material.emissive.setRGB(
          child.material.originalEmissive.r + intensity * 0.5,
          child.material.originalEmissive.g + intensity * 0.5,
          child.material.originalEmissive.b + intensity * 0.1
        );
      }
    });
  }
}

// webpack 빌드를 위해 default export 추가
export default Star;

// 전역 변수로도 등록 (기존 코드 호환성)
window.Star = Star;